import React, { useEffect } from 'react';
import { getMerchantAppOrigin } from '@/utils/appConfig';

const MerchantToolsRedirect: React.FC = () => {
  useEffect(() => {
    window.location.replace(`${getMerchantAppOrigin()}/merchant-tools`);
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <p className="text-gray-600">Redirecting to Merchant Tools...</p>
      </div>
    </div>
  );
};

export default MerchantToolsRedirect;
